gz-title {
  color: var(--chart-300-icon-buttons);
}

gz-form-field {
  --form-field-label-width: 134px;
  &::part(form-field-label) {
    max-width: 134px;
  }
}

gz-form-field {
  --margin-bottom-wrapper: var(--spacer);
}

gz-copy-to-clipboard {
  float: right;
}
